import { useEffect } from 'react';
import { useSocketStore, useGameStore } from './stores/socketStore';
import { LobbyView } from './components/lobby/LobbyView';
import { GameView } from './components/game/GameView';
import './styles/App.css';

function App() {
  const { isConnected, connectionError } = useSocketStore();
  const { gameState } = useGameStore();

  useEffect(() => {
    // Connect to socket server
    useSocketStore.getState().connect();
  }, []);

  if (connectionError) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-lg">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Connection Error</h1>
          <p className="text-gray-700">{connectionError}</p>
          <button
            onClick={() => useSocketStore.getState().connect()}
            className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!isConnected) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-600">Connecting to server...</p>
        </div>
      </div>
    );
  }

  return <div className="min-h-screen bg-gray-100">{gameState ? <GameView /> : <LobbyView />}</div>;
}

export default App;
